import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { ChallengeStore } from '@seedlang/stores';
import CheckIfTrue from 'components/check_if_true';
import Paginator from 'components/paginator';
import { Link } from 'react-router';

const Wrapper = styled.div`

`;

@observer
class ChallengeIndex extends React.Component {

  constructor(props) {
    super(props);
    ChallengeStore.getIndex();
  }

  render() {
    return (
      <Wrapper>
        <table className='table-wrapper admin-table'>
          <thead>
            <tr>
              <th>Created</th>
              <th>Challenger</th>
              <th>Challengee</th>
              <th>Tree Node</th>
              <th>Challengee Finishes Match</th>
            </tr>
          </thead>
          <tbody>
            {
              ChallengeStore.indexData.map(item => {
                return (
                  <tr key={item.id}>
                    <td>
                      <div className='text'>
                        {item.createdAt.formatted}
                      </div>
                    </td>
                    <td>
                      <div className='text'>
                        {
                          item.user &&
                            <Link
                              to={{name: 'builder.users.edit', params: {userId: item.user.id}}}
                            >
                              {item.user.name}
                            </Link>
                        }
                      </div>
                    </td>
                    <td>
                      <div className='text'>
                        {
                          item.challengee &&
                            <Link
                              to={{name: 'builder.users.edit', params: {userId: item.challengee.id}}}
                            >
                              {item.challengee.name}
                            </Link>
                        }
                      </div>
                    </td>
                    <td>
                      <div className='text'>
                        {item.treeNode && item.treeNode.name}
                      </div>
                    </td>
                    <td>
                      <div className='text'>
                        <CheckIfTrue
                          value={item.challengeeFinishedMatch}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        <Paginator
          store={ChallengeStore}
        />
      </Wrapper>
    );
  }
}

export default ErrorBoundary(ChallengeIndex);
